/**
 * @fileoverview added by tsickle
 * Generated from: formio.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormioComponent } from './components/formio/formio.component';
import { FormBuilderComponent } from './components/formbuilder/formbuilder.component';
import { FormioAlerts } from './components/alerts/formio.alerts';
import { FormioAlertsComponent } from './components/alerts/formio.alerts.component';
import { FormioLoader } from './components/loader/formio.loader';
import { FormioLoaderComponent } from './components/loader/formio.loader.component';
import * as ɵngcc0 from '@angular/core';
var FormioModule = /** @class */ (function () {
    function FormioModule() {
    }
FormioModule.ɵfac = function FormioModule_Factory(t) { return new (t || FormioModule)(); };
FormioModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: FormioModule });
FormioModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        FormioLoader,
        FormioAlerts
    ], imports: [[
            CommonModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormioModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    FormioComponent,
                    FormBuilderComponent,
                    FormioLoaderComponent,
                    FormioAlertsComponent
                ],
                imports: [
                    CommonModule
                ],
                exports: [
                    FormioComponent,
                    FormBuilderComponent,
                    FormioLoaderComponent,
                    FormioAlertsComponent
                ],
                providers: [
                    FormioLoader,
                    FormioAlerts
                ],
                entryComponents: [
                    FormioComponent,
                    FormBuilderComponent
                ]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FormioModule, { declarations: function () { return [FormioComponent,
        FormBuilderComponent,
        FormioLoaderComponent,
        FormioAlertsComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [FormioComponent,
        FormBuilderComponent,
        FormioLoaderComponent,
        FormioAlertsComponent]; } }); })();
    return FormioModule;
}());
export { FormioModule };

